//import React from "react";

export const english = {
	abbr: "en_US",
	home: "Home",
	partner: "We are partner of",
	yourName: "Name",
	calculator: "Calculator",
	yourOpinion: "Your opinion",
	opinionOkMessage: "Thank you! The opinion will be published after moderation",
	notEmpty: "Please fill all fields before submit",
	fotovideo: "Portfolio",
	prices: "Prices",
	slogan: "Photography & Videography",
	opinion: "Opinions",
	contact: "Contact",
	need_date: "The date must be choosen!",
	need_recaptcha: "You need to check recaptcha!",
	need_email: "Please provide a valid email address",
	error: "Sorry, an error occured",
	success: "Sended successfully",
	acceptTitle: "Contact",
	sent_ok: "Thank you! We will contact to you soon",
	disclaimer:
		"The presented price offer is for information purposes only and does not constitute as an offer within the meaning of Art.66 par.1 of the Civil Code",
	disclaimer2:
		"In order to agree the details of the order and sign the contract you will receive an offer at the email",
	slogan_1:
		"Each wedding is unique. Our films it's incredible memories, true love, interesting scenario, satisfacted parents and happy guests. Get the beautiful professional photos and that happy moments will stay with you for life",
	online_calc: "Online Calculator",
	invalid_date: "Invalid date or unknown error",
	need_city: "You must choose a wedding location!",
	calc_desc:
		"Want to calculate the total amounts of your package by yourself? Take our online calculator and choose only those services that you really need",
	i18n: {
		done: "Ok",
		cancel: "Cancel",
		months: [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		],
		weekdaysAbbrev: [ "S", "M", "T", "W", "T", "F", "S" ],
		weekdaysShort: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
		monthsShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	},
	antibot: "Anti-bot check",
	enter_date: "Choose wedding date",
	busy: "Unfortunately picked date  has already been taken. Try to choose another date, please",
	check: "Check it",
	no_internet: "Check error. No internet connection",
	no_date: "The date is a requirement parameter",
	need_time: "Set the working time for our team",
	need_zdje:
		"You choose a package that includes Photographer but didn't choose a count of photos in 'Standard package of photos' section",
	wait: "Wait, checking the date...",
	pakiet: "Package",
	accept: "Send for review",
	used_by: "Was used by",
	clients: "clients",
	services: "Our services",
	portfolio: "Our portfolio",
	callback: "Drop a message",
	callback_desc: "Have a question or want to preoder? Drop a message and we'll call you back",
	services_adv: "Each service could be discussed individually with the Client",
	retush: "Professional",
	retush_name: "Retouching",
	no_price: "from 10$",
	no_price_desc: "per one photo",
	ask: "Ask a question",
	chat_greet: "Hello, how can we help you? Feel free to ask about our services",
	portfolio_imgs_title: "Photos",
	portfolio_films_title: "Wedding clips",
	postalCode: "City postal code",
	pickedDate: "Your wedding date:",
	pickCity: "Choose the city",
	cityFound: "Found cities: ",
	steps_end: "Congrats, we're ready to proceed calculation",
	send_calc: "Calculate",
	testimonials: "Our testimonials",
	addOpinion: "Add testimonial",
	navi:"navigate",
	warning: "Unauthorized access! Reopen the calculator and go through the anti-bot check",
	il9n: {
		next: "Next",
		prev: "Prev",
		finish: "Finish",
		yourTeam: "Chosen service",
		yourTime: "Work time",
		yourAdditional: "Additional services",
		noAdditional: "There is no additional services chosen",
		yourTimeFrom: "Working time from",
		yourTimeTo: "till",
		step1: "Choose a team",
		step2: "Specify additional services",
		step3: "Choose our working time",
		$1w: "1 operator",
		$desc_1w:
			"The work of one operator is to capture all the wedding events on this day. This is the cheapest option however there are some limitations. For example, it is not possible to use a drone and the simultaneous performance of operator duties by one person",
		$2w: "2 operators",
		$desc_2w:
			"Two operators use various camera positioning techniques that allow you to record an interesting wedding celebration scenes",
		$1w1f: "1 operator + 1 photographer",
		$2w1f: "2 operators + 1 photographer",
		$1f: "1 photographer",
		$czas_0: "Church - the first dance",
		$czas_1: "Church - tossing a bouquet (oczepiny)",
		$czas_2: "Blessings - the first dance",
		$czas_3: "Blessings - tossing a bouquet (oczepiny)",
		$czas_4: "Preparations - the first dance",
		$czas_5: "Preparations - tossing a bouquet (oczepiny)",
		IZDE: "Standard package of photos",
		IRETUSZ: "Professional photo retouching",
		SESSNAZ: "Wedding photo session",
		SESSPOS: "Photo session of the newlyweds",
		FOTOKS: "Photobook",
		LOVESTORY: "LoveStory (video)",
		PRODZ: "Gratitude to parents (video)",
		PLENER: "Walk",
		DRON: "Drone",
		same_day: "In the same day",
		another_day: "In another day (by agreement)",
		unit: "pcs."
	}
};

export const poland = {
	abbr: "pl_PL",
	home: "Start",
	partner: "Jesteśmy partnerem",
	calculator: "Kalkulator",
	yourName: "Imie",
	yourOpinion: "Twoja opinia",
	opinionOkMessage: "Dziękujemy! Twoja opinia zostanie dodana po moderacji",
	notEmpty: "Wypełnij wszystkie pola przed dodawaniem",
	fotovideo: "Portfolio",
	prices: "Oferta",
	slogan: "Photography & Videography",
	error: "Nie powiodło się. Wypełnij wszystkie pola",
	success: "Wysłano pomyślnie",
	opinion: "Opinie",
	contact: "Kontakt",
	need_date: "Data musi być wskazana!",
	need_email: "Musisz wprowadzić poprawny email",
	invalid_date: "Invalid date or unknown error",
	need_city: "Miejscowość musi być wskazana!",
	need_zdje: "Wybrałeś pakiet z fotografem ale nie zaznaczyłeś ilość zdjęć w Standardowym pakiecie zdęć",
	accept: "Wyślij do uzgodnienia",
	sent_ok: "Dziękujemy! Skontaktujemy się z Tobą wkrótce",
	acceptTitle: "Kontakt",
	kurs: "Posiadamy bezterminowe pozwolenie Archidiecezji Lubelskiej do nagrywania ",
	disclaimer:
		"Przedstawiona oferta cenowa ma charakter informacyjny i nie stanowi oferty handlowej w rozumieniu Art.66 par.1 Kodeksu Cywilnego",
	disclaimer2:
		"Co do uzgodnienia szczegółów zamówienia oraz podpisania umowy otrzymacie Państwo ofertę na podany adres email",
	slogan_1:
		"Każdy nasz film jest wyjątkowy. Filmy które kręcimy - to wesołe wspomnienia, prawdziwa miłość, ciekawy  scenariusz, zadowoleni rodzice i radośni goście. Zyskaj piękne profesjonalne zdjęcia. I te niepowtarzalne momenty zostaną z Tobą na zawsze",
	online_calc: "Online Kalkulator",
	calc_desc:
		"Chcesz sam decydować o całkowitej kwocie swojego pakietu? Skorzystaj z naszego kalkulatora i wybierz tylko te usługi, których potrzebujesz",
	i18n: {
		done: "Ok",
		cancel: "Powrót",
		months: [
			"Styczeń",
			"Luty",
			"Marzec",
			"Kwiecień",
			"Maj",
			"Czerwiec",
			"Lipiec",
			"Sierpień",
			"Wrzesień",
			"Październik",
			"Listopad",
			"Grudzień"
		],
		weekdaysAbbrev: [ "Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "Sb" ],
		weekdaysShort: [ "Niedz", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob" ],
		monthsShort: [ "Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru" ]
	},
	antibot: "Anty-bot weryfikacja",
	enter_date: "Wskaż datę ślubu",
	busy: "Niestety wybrana data jest już zarezerwowana, spróbuj wybrać inną",
	need_time: "Podaj planowany czas naszej pracy",
	check: "Sprawdź",
	no_internet: "Nie powiodło się. Sprawdź połączenie z siecią",
	no_date: "Data musi być wskazana",
	need_recaptcha: "Anty-bot weryfikacja nie zaznaczona!",
	wait: "Czekaj, trwa sprwadzanie...",
	pakiet: "Pakiet",
	used_by: "Wykorzystało",
	clients: "osób",
	services: "Nasza oferta",
	portfolio: "Nasze portfolio",
	callback: "Proszę oddzwonić do mnie",
	callback_desc: "Masz pytania lub chcesz uzgodnić termin? Wyslij zapytanie, oddzwonimy do Ciebie",
	services_adv: "Każdy pakiet może być uzgodniony indywidualnie z Klientem",
	retush: "Profesjonalny",
	retush_name: "Retusz",
	no_price: "od 10$",
	no_price_desc: "za 1 foto",
	ask: "Zadać pytanie",
	chat_greet: "Witaj, interesują Cię nasze usługi? Odpowiemy na wszystkie pytania",
	portfolio_imgs_title: "Zdjęcia",
	portfolio_films_title: "Ślubne teledyski",
	postalCode: "Kod pocztowy miejscowości",
	pickedDate: "Data ślubu:",
	pickCity: "Wybierz miejscowość",
	cityFound: "Znależiono: ",
	steps_end: "Gratulacje, wszystko gotowe do obliczenia",
	send_calc: "Oblicz",
	testimonials: "Opinie o nas",
	navi:"nawigacja",
	addOpinion: "Dodać opinie",
	warning: "Nieautoryzowany dostęp! Ponownie otwórz kalkulator i przejdź przez kontrolę anty-bot",
	il9n: {
		next: "Dalej",
		prev: "Cofnij",
		finish: "Zakończ",
		yourTeam: "Wybrany pakiet",
		yourTime: "Czas pracy",
		yourAdditional: "Dodatkowe usługi",
		noAdditional: "Dodatkowe usługi nie zostały wybrane",
		yourTimeFrom: "Czas pracy od",
		yourTimeTo: "do",
		step1: "Wybierz ekipę",
		step2: "Wybierz dodatkowe usługi",
		step3: "Wybierz czas naszej pracy",
		$1w: "1 kamerzysta",
		$desc_1w:
			"Praca jednego kamerzysty polega na nagraniu uroczystości w dniu ślubu. Jest to najtańszym rozwiązaniem jednak są pewne ograniczenia. Na przykład nie jest możliwe wykorzystanie drona a jednoczesne spełnienie obowiązku nagrania urocztstości przez jedną osobę",

		$2w: "2 kamerzysty",
		$desc_2w:
			"Dwoch operatorów wykorzystują różne techniki ustawiania kamer co pozwala na nagranie i montaż ciekawych scen uroczystości ślubnych",
		$1w1f: "1 kamerzysta + 1 fotograf",
		$desc_1w1f: "Jeden kamerzysta oraz jeden fotograf to jest optymalne rozwiązanie dla twojego budżetu",
		$2w1f: "2 kamerzysty + 1 fotograf",
		$desc_2w1f:
			"Podstawowa ekipa z dwoch operatorów oraz fotografa jest najlepszą opcją ponieważ pozwala na wykorzystanie maksymalnej ilości dostępnych usług. Z taką ekipą twój ślub będzie nagrany w najlepszej jakości",
		$1f: "1 fotograf",
		$desc_1f:
			"Jeżeli potrzebujesz tylko jednego fotografa to dany pakiet przedstawi dla Ciebie pełen zakres usług związanych z pracą fotografa podczas uroczystości ślubnych",
		$czas_0: "Kosciół - pierwszy taniec",
		$czas_1: "Kościół - oczepiny",
		$czas_2: "Błogosławieństwo - pierwszy taniec",
		$czas_3: "Błogosławieństwo - oczepiny",
		$czas_4: "Przygotowania - pierwszy taniec",
		$czas_5: "Przygotowania - oczepiny",
		IZDE: "Standardowy pakiet zdęć",
		IRETUSZ: "Profesjonalnie retuszowane zdjęcia",
		SESSNAZ: "Sesja narzeczeńska",
		SESSPOS: "Sesja poślubna",
		FOTOKS: "Fotoksiążka",
		LOVESTORY: "LoveStory (wideo)",
		PRODZ: "Podziękowanie rodzicom (wideo)",
		PLENER: "Plener",
		DRON: "Dron",
		same_day: "W tym samym dniu",
		another_day: "W innym dniu (do uzgodnienia)",
		unit: "szt."
	}
};

export const russian = {
	abbr: "ru_RU",
	home: "Главная",
	partner: "Наш партнер",
	calculator: "Калькулятор",
	addOpinion: "Добавить отзыв",
	yourName: "Имя",
	yourOpinion: "Ваш отзыв",
	accept: "Выслать на рассмотрение",
	opinionOkMessage: "Спасибо! Ваш отзыв появится на сайте после модерации",
	notEmpty: "Пожалуйста заполните все поля перед отправкой отзыва",
	need_time: "Укажите время нашей работы",
	fotovideo: "Портфолио",
	prices: "Услуги",
	slogan: "Фотография & Видеосъемка",
	opinion: "Отзывы",
	contact: "Контакт",
	kurs: "",
	navi:"навигация",
	error: "Упс, произошла ошибка",
	success: "Запрос отправлен успешно",
	acceptTitle: "Обратная связь",
	sent_ok: "Спасибо! Мы свяжемся с Вами в ближайшее время",
	disclaimer:
		"Представленное ценовое предложение предназначено для информационных целей и не является коммерческим предложением согласно ст.66 ч.1 Гражданского кодекса",
	disclaimer2:
		"Для согласования деталей заказа и подписания договора на указанный адрес email вы получите дополнительную информацию",
	need_date: "Дата обязательно должна быть указана!",
	need_recaptcha: "Вы не прошли анти-бот проверку!",
	need_email: "Необходимо ввести реальный адрес email",
	need_zdje: "Вы выбрали Фотографа однако не указали количество фотографий в разделе <Стандартный пакет фотографий>",
	invalid_date: "Invalid date or unknown error",
	need_city: "Вы должны указать место проведения свадьбы!",
	slogan_1:
		"Каждая свадьба неповторима. Наши фильмы - это незабываемые моменты, настоящая любовь, интересный сюжет, радостные гости и довольные родители. Профессиональный подход и качественное обслуживание. Пусть эти неповторимые минуты останутся навсегда с тобой",
	online_calc: "Онлайн Калькулятор",
	calc_desc:
		"Хочешь самостоятельно выбрать стоимость своего пакета? Воспользуйся нашим калькулятором и выбери только те услуги, которые тебе нужны",
	i18n: {
		done: "Ok",
		cancel: "Отмена",
		months: [
			"Январь",
			"Февраль",
			"Март",
			"Апрель",
			"Май",
			"Июнь",
			"Июль",
			"Август",
			"Сентябрь",
			"Октябрь",
			"Ноябрь",
			"Декабрь"
		],
		monthsShort: [ "Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек" ],
		weekdaysAbbrev: [ "Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб" ],
		weekdaysShort: [ "Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб" ]
	},
	antibot: "Анти-бот проверка",
	enter_date: "Укажите дату свадьбы",
	busy: "К сожалению, выбранная дата уже зарезервирована. Вы можете попробовать выбрать другую дату",
	check: "Проверить",
	no_internet: "Ошибка соединения. Провертьте интернет",
	no_date: "Необходимо указать дату",
	wait: "Подождите, идет проверка...",
	pakiet: "Пакет",
	retush: "Профессиональная",
	retush_name: "Ретушь",
	used_by: "Воспользовались",
	clients: "клиентов",
	services: "Наши услуги",
	portfolio: "Наше портфолио",
	callback: "Перезвоните мне",
	callback_desc: "Остались вопросы или хочешь обговорить детали? Вышли нам сообщение и мы перезвоним",
	services_adv: "Каждый пакет услуг может быть обговорен индивидуально с Клиентом",
	no_price: "от 10$",
	no_price_desc: "за 1 фото",
	ask: "Задать вопрос",
	chat_greet: "Добрый день, хотите обсудить детали заказа? Мы ответим на любые вопросы",
	portfolio_imgs_title: "Фотоальбом",
	portfolio_films_title: "Свадебные клипы",
	postalCode: "Почтовый код города",
	pickedDate: "Дата свадьбы:",
	pickCity: "Укажите населенный пункт",
	cityFound: "Найдено:",
	testimonials: "Наши отзывы",
	steps_end: "Поздравляем, все готово к подсчету",
	send_calc: "Подсчитать",
	warning: "Неавторизированный доступ! Заново откройте калькулятор и пройдите анти-бот проверку",
	il9n: {
		next: "Далее",
		prev: "Назад",
		finish: "Завершить",
		yourTeam: "Выбранный пакет",
		yourTime: "Время работы",
		yourAdditional: "Дополнительные услуги",
		noAdditional: "Не выбрано ни одной дополнительной услуги",
		yourTimeFrom: "Время работы от",
		yourTimeTo: "до",
		step1: "Выбери команду",
		step2: "Уточните дополнительные услуги",
		step3: "Укажите время нашей работы",
		$1w: "1 оператор",
		$desc_1w:
			"Работа одного оператора заключается в запечатлению всех свадебных торжеств в этот день. Это наиболее дешевый вариант однако есть некоторые ограничения. Например не представляется возможным использование квадрокоптера и одновременное исполнение обязанностей оператора одним человеком",
		$2w: "2 оператора",
		$desc_2w:
			"Два оператора используют различные методы позиционирования камеры, которые позволяют записывать и монтировать интересные сцены свадебных торжеств",
		$1w1f: "1 оператор + 1 фотограф",
		$2w1f: "2 оператора + 1 фотограф",
		$1f: "1 фотограф",
		$czas_0: "Церковь - первый танец",
		$czas_1: "Церковь - бросание букета (oczepiny)",
		$czas_2: "Блогославение - первый танец",
		$czas_3: "Блогославение - бросание букета (oczepiny)",
		$czas_4: "Приготовления - первый танец",
		$czas_5: "Приготовления - бросание букета (oczepiny)",
		IZDE: "Стандартный пакет фотографий",
		IRETUSZ: "Профессиональная ретушь фотографий",
		SESSNAZ: "Свадебная фотосессия",
		SESSPOS: "Фотосессия молодоженов",
		FOTOKS: "Фотокнига",
		LOVESTORY: "LoveStory (видео)",
		PRODZ: "Благодарность родителям (видео)",
		PLENER: "Прогулка",
		DRON: "Квадрокоптер",
		same_day: "В день свадьбы",
		another_day: "В любой другой день после свадьбы (по согласованию)",
		unit: "шт."
	}
};
